export const userRole = {
    Counselor : 'Counselor',
    Administrator: 'Administrator',
    'RSA Staff' : 'RSA Staff',
    "Employment Coordinator": "Employment Coordinator",
    "Coordinator Supervisor": "Coordinator Supervisor"
};